<template>
  <div class="Inspection7">
    <h1 id="heading">Bewertung der Umgebungsbedingungen</h1>
    <v-divider></v-divider>
    <div>
      <v-data-table
        :headers="headers"
        :items-per-page="5"
        :items="items"
        item-key="name"
        class="DataTable"
        hide-default-footer
      >
        <template slot="item" slot-scope="props">
          <tr @click="props.expanded = !props.expanded">
            <td class="text-xs-left" style="font-size: 120%">{{ props.item.name }}</td>
            <td class="text-xs-left" style="font-size: 120%">{{ props.item.assess }}</td>
            <td>
              <input
                type="radio"
                v-model="assessment"
                :key="props.item.assess"
                :value="props.item.assess"
              >
            </td>
          </tr>
        </template>
      </v-data-table>
      <div class="description">
        <v-dialog v-model="dialog" max-width="500px" :retain-focus="false">
          <template v-slot:activator="{ on }">
            <v-btn color="green" slot="activator" x-small fab v-on="on">
              <v-icon color="white" small>fas fa-info</v-icon>
            </v-btn>
          </template>
          <v-card>
            <v-toolbar color="green" height="50px">
              <v-toolbar-title style="color: white; font-size: 150%">Umgebungsbedingungen</v-toolbar-title>

              <v-spacer></v-spacer>

              <v-btn @click="close" small icon>
                <v-icon color="white">fas fa-times</v-icon>
              </v-btn>
            </v-toolbar>

            <v-img :src="require('../../statics/images/Blitzschlag.jpg')" height="150px"></v-img>

            <v-card-text style="font-size: 100%;">
              <img
                :src="require('../../statics/images/blitzEinstufung.jpg')"
                style="width: 50%"
              >
              <p>
              <br>
              
                <!-- <a href="https://oe3.orf.at/stories/2858048/" target="_blank">Karte</a> -->
                <a href="https://oe3.orf.at/stories/2858048/" target="_blank">Quelle -> siehe interaktive Blitzkarte!</a>
                <br>
                <br>
                <strong>Hohe Gefährdung durch Blitzschläge</strong>
                <br>=> über 2 Blitzschlägen pro Jahr
                <br>
                <br>
                <strong>Mäßige Gefährdung durch Blitzschläge</strong>
                <br>=> unter 2 Blitzschläge pro Jahr
                <br>
                <br>
                <strong>Keine Gefährdung durch Blitzschläge</strong>
                <br>=> Tunnelanlagen 
              </p>
            </v-card-text>
          </v-card>
        </v-dialog>
      </div>
      <v-divider></v-divider>
      <v-btn color="blue" @click="nextPage" small fab>
        <v-icon color="white">fas fa-arrow-right</v-icon>
      </v-btn>
    </div>
  </div>
</template>

<script>
export default {
  name: "Inspection7",
  props: ["assessmen"],
  data() {
    return {
      assessment: 0,
      assessName: "",
      assessHeader: "",
      dialog: false,
      items: [
        { name: "Keine Gefährung durch Blitzschläge", assess: 0 },
        { name: "Mäßige Gefährung durch Blitzschläge", assess: 1 },
        { name: "Hohe Gefährung durch Blitzschläge", assess: 2 }
      ],
      headers: [
        {
          text: "Alle Arten von Anlagen",
          align: "left",
          sortable: false,
          value: "name"
        },
        { text: "Relative Bewertung", sortable: false, value: "assess" }
      ]
    };
  },
  methods: {
    nextPage() {
      switch (this.assessment) {
        case 0:
          this.assessName = "Keine Gefährung durch Blitzschläge";
          break;
        case 1:
          this.assessName = "Mäßige Gefährung durch Blitzschläge";
          break;
        case 2:
          this.assessName = "Hohe Gefährung durch Blitzschläge";
          break;
      }
      this.assessmen = this.assessmen + this.assessment;
      this.assessHeader = "Umgebungsbedingungen";

      this.$emit("assessChanged", this.assessmen);
      this.$emit("assessmentName", this.assessName);
      this.$emit("assessmentHeader", this.assessHeader);
      this.$emit("assessmentActual", this.assessment);
      this.$emit("InspBefore", false);
      this.$emit("InspActual", true);
    },
    close() {
      this.dialog = false;
    }
  }
};
</script>

<style>
.Inspection7 {
  background-color: white;
  width: 70%;
  margin: 1% auto 0% auto;
  border: 1px solid black;
  border-radius: 5px;
  text-align: center;
}

.DataTable {
  width: 90%;
  margin-left: 5%;
}

#heading {
  font-size: 200%;
}
</style>
